import { ENV } from "../../../config/env";

export const surveyQueuesConstants = {
  GET_SURVEY_QUEUES: "GET_SURVEY_QUEUES",
  SEND_EMAIL_MESSAGE: "SEND_EMAIL_MESSAGE",
};

export const defaultSubjectsList = [
  { id: 0, label: "Select Subject", value: "" },
  { id: 1, label: "Confirm your account", value: "Confirm your account" },
  {
    id: 2,
    label: "Help Request from HR360M - Dashboard",
    value: "Help Request from HR360M - Dashboard",
  },
  {
    id: 3,
    label: "Invitation to Join HungerRush Account",
    value: "Invitation to Join HungerRush Account",
  },
  { id: 4, label: "Reset your password", value: "Reset your password" },
  {
    id: 5,
    label: `${ENV.SURVEY_QUEUES}:Survey Application Started`,
    value: `${ENV.SURVEY_QUEUES}:Survey Application Started`,
  },
  {
    id: 6,
    label: `${ENV.SURVEY_QUEUES}:Survey Application Stopped`,
    value: `${ENV.SURVEY_QUEUES}:Survey Application Stopped`,
  },
  {
    id: 7,
    label: "Survey Response For All Questions",
    value: "Survey Response For All Questions",
  },
  {
    id: 8,
    label: "Survey Data Export",
    value: "Survey Data Export",
  },
  { id: 9, label: "Message from", value: "Message from" },
  {
    id: 10,
    label: "Important: This Email Address is Not Monitored",
    value: "Important: This Email Address is Not Monitored",
  },
];
